// Fuentes para el editor: reusa el catálogo self-hosted de Atlas (TEXT_FONT_OPTIONS,
// @fontsource, ya cargado global en main.tsx). `fontStack` agrega el fallback por
// categoría; las capas guardan solo el `family` y el render/compositor arman la stack.

import { TEXT_FONT_OPTIONS, type FontCategory } from '../../../lib/fontOptions';

const FALLBACK: Record<FontCategory, string> = {
  sans: 'sans-serif',
  serif: 'serif',
  display: 'sans-serif',
  handwriting: 'cursive',
  mono: 'monospace',
};

export function fontStack(family: string): string {
  const opt = TEXT_FONT_OPTIONS.find((o) => o.family === family);
  return `"${family}", ${FALLBACK[opt?.category ?? 'sans']}`;
}

export const DEFAULT_FONT_FAMILY = 'Poppins';
export { TEXT_FONT_OPTIONS };
